module.exports = __webpack_public_path__ + "img/76.2.TN.f0cb6342.png";